import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';
import { PatientAuthenticationService } from '../services/patientAuthentication.service';
import {UserService} from '../../../services/user.service';
import {Globals} from '../../../globals';
import {LocalStorageService} from '../../../services/local-storage.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  patientRoutes: string[] = [
    '/patientportal'
  ];

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private patientAuthService: PatientAuthenticationService,
    private userService: UserService,
    private globals: Globals,
    private localStorageService: LocalStorageService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.localStorageService.currentUserData;
    if (!localStorage.getItem('storedUser') || !currentUser || (currentUser && !currentUser.authdata)) {
      if (this.router.url.includes('configuration') || this.router.url.includes('scheduler') 
          || this.router.url.includes('forms/builder') || this.router.url.includes('studio') 
          || this.router.url.includes('reports') || route.routeConfig.path === "configuration")
        window.close();
      else if (!this.router.url.includes('/login')){
        this.router.navigate(['/login']);
      }
      return false;
    }

    return true;    
  }  

  // Check to see if the user using a TDO12 token.
  // If the user is logged in, log them out and ask for authentication
  hasTDO12Token(route: ActivatedRouteSnapshot) {
    for (const element of route.url) {
      const url = element;
      if (url.path === 'handleToken') {
        if (this.hasHandleTokenFlag()) {
          this.clearHandleTokenFlag();
          return false;
        } else {
          this.authenticationService.logout();
          this.setHandleTokenFlag();
          return true;
        }
      }
    }
    return false;
  }

  clearHandleTokenFlag() {
    localStorage.removeItem('handleTDO12TokenFlag');
  }

  setHandleTokenFlag() {
    localStorage.setItem('handleTDO12TokenFlag', 'true');
  }

  hasHandleTokenFlag() {
    const flag = localStorage.getItem('handleTDO12TokenFlag');
    return !!flag;
  }

}


